import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "廃車買い取りをご利用いただいたお客様の声", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "text-center" }

import { ref, reactive } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import api from '@/estimate/api'
import { ReviewList } from '@/estimate/components'
import { Review } from '@/estimate/models'

/** 買い取り実績一覧 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const reviewList = ref<Review[]>([])

/** ページネーションデータ */
const pagination = reactive({
  sortBy: 'reviewDay', // 初期ソートカラム
  descending: true, // 初期ソート順 降順=true 昇順=false
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 0,
})

/** 廃車買い取り実績一覧取得タスク */
const getRecordTask = useAsyncTask(async (signal, query) => {
  return api.review.list({ ...query }).then(res => {
    reviewList.value = res.reviewList
    Object.assign(pagination, res.pagination)
  })
})

getRecordTask.perform({ filter: { publishFlg: true }, pagination })

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, _hoisted_2, 2),
    _createVNode(_unref(ReviewList), {
      data: reviewList.value,
      class: "q-my-md"
    }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_btn, {
        unelevated: "",
        label: "お客様の声一覧を見る",
        color: "brand",
        size: "lg",
        "icon-right": "fas fa-arrow-circle-right",
        to: "/review"
      })
    ])
  ], 2))
}
}

})